// store/index.js
import { createStore } from 'vuex';

export default createStore({
    state: {
        // 定义全局变量
        globalVariable: 'Hello from Vuex!',
        avatarUrl: "",
        expireTime: "1970-01-01 00:00:00",
        headerExpireDialog: false,
        isExpired: false,
        secret: "",
        InviterCode: "点击生成",
        DailiInfo: {},
        CodeLevel: 0,
        currentInfo: {},
        websocket: null,
        selfRules: [],
        baseRemoteUrl: "https://api.8188811.xyz",
        globalMessage: [
            { id: 1, title: '欢迎', time: '2024-12-02 10:00', content: '欢迎使用幻音阁!' },
        ],
        unreadNum: 0
    },
    mutations: {
        // 定义修改全局变量的方法
        setGlobalVariable(state, newValue) {
            state.globalVariable = newValue;
        },
        setCodeLevel(state, newValue) {
            state.CodeLevel = newValue;
        },
        setDailiInfo(state, newValue) {
            state.DailiInfo = newValue;
        },
        setInviterCode(state, newValue) {
            state.InviterCode = newValue;
        },
        setSecret(state, newValue) {
            state.secret = newValue;
        },
        setHeaderExpireDialog(state, newValue) {
            state.headerExpireDialog = newValue;
        },
        setWebsocket(state, newValue) {
            state.websocket = newValue;
        },
        setSelfRules(state, newValue) {
            state.selfRules = newValue;
        },
        setExpireTime(state, newValue) {
            state.expireTime = newValue;
        },
        setIsExpired(state, newValue) {
            state.isExpired = newValue;
        },
        setCurrentInfo(state, newValue) {
            state.currentInfo = newValue;
        },
        setAvatarUrl(state, newValue) {
            state.avatarUrl = newValue;
        },
        setGlobalMessage(state, newValue) {
            state.globalMessage = newValue;
        },
        setUnreadNum(state, unreadNum) {
            state.unreadNum = unreadNum;
        },
    },
    actions: {
        // 定义异步操作，如果有需要的话
    },
    modules: {
        // 如果你有模块化的需求，可以在这里配置模块
    },
});
